import {
  Card,
  Grid,
  Stack,
  Typography,
} from "@compass/core";
import { ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabG = (props: {
  properties: ModelPropertyBase[] | undefined;
}) => {

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Participants with Limited English Proficiency</Typography>
        <Grid container spacing="lg">
        </Grid>
      </Stack>
    </Card>
  );
};
